import axios from "axios";

const getPatientAppointmentByBarcode = async (baseUrl, token, patientId, barcode) => {

    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    let getResponse = null 

    await axios.get(baseUrl + `/patient/` + patientId + "/appointment/barcode/" + barcode, config)
        .then((res) => {
            //console.log("res.data: ", res.data)
            getResponse = {
                status: res.data.status,
                data: res.data.data
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                getResponse = {
                    status: error.response.status,
                    result: error.response.status
                }
            }
        });
    return getResponse
}

export default getPatientAppointmentByBarcode;